import { queryParamsModule } from '../../../modules/queryParams';

export class OnboardingParamsTool {
  static setParam(key: string, value: string | string[]): void {
    if (Array.isArray(value)) {
      queryParamsModule.setParamsList(key, value);
    } else {
      queryParamsModule.setParam(key, value);
    }
  }

  static getParam<Key extends string = string>(key: Key): string | null {
    return queryParamsModule.getParam(key);
  }

  static getParamsList<Key extends string = string>(key: Key): string[] {
    return queryParamsModule.getParamsList(key);
  }
}
